<template>
    <div>
        <h3 class="mobile-text-center mt-4 mt-md-0 h3-small">
            <translate translation-key="tools.activityOverview"
                       :replacements="{name: dapp.name}"
                       :fallback="dapp.name + ' Activity Overview'" />
        </h3>
        <div class="table-responsive px-lg-0 px-0 px-sm-3">
            <div class="time-frame-switch float-left">
                <button type="button"
                        class="time-frame-switch-period"
                        :class="[time_frame === '1w' ? 'time-frame-switch-period-active' : '']"
                        @click="change_time_frame('1w')">
                    <translate translation-key="time.sevenDays"
                               fallback="7D" />
                </button>
                <button type="button"
                        class="time-frame-switch-period"
                        :class="[time_frame === '1m' ? 'time-frame-switch-period-active' : '']"
                        @click="change_time_frame('1m')">
                    <translate translation-key="time.thirtyDays"
                               fallback="30D" />
                </button>
                <button type="button"
                        class="time-frame-switch-period"
                        :class="[time_frame === '3m' ? 'time-frame-switch-period-active' : '']"
                        @click="change_time_frame('3m')">
                    <translate translation-key="time.ninetyDays"
                               fallback="90D" />
                </button>
            </div>
        </div>
        <transactions-chart v-if="dates"
                            :key="'transactions-' + dates.length"
                            :dates="dates"
                            :transactions="transactions"
                            :users="users"
                            :volume="volume" />
    </div>
</template>

<script>
    import TransactionsChart from './TransactionsChart.vue';

    export default {
        name: 'TransactionsMainChart',
        components: {
            TransactionsChart,
        },
        props: {
            dapp: {
                type: [Array, Object],
                default: () => [],
                required: true,
            },
        },
        data() {
            return {
                time_frame: '1w',
                dates: null,
                transactions: null,
                users: null,
                volume: null,
            };
        },
        mounted() {
            this.getResults();
        },
        methods: {
            change_time_frame(timeFrame) {
                this.time_frame = timeFrame;
                this.getResults();
            },
            getResults() {
                axios.get(`/api/dapp-transactions?dapp=${this.dapp.id}&time_frame=${this.time_frame}`)
                    .then((response) => {
                        this.dates = response.data.dates;
                        this.transactions = response.data.transactions;
                        this.users = response.data.users;
                        this.volume = response.data.volume;
                    });
            },
        },
    };
</script>
